export const routerPaths = {
  dashboard: '/dashboard',
  home: '/app',
  classification: '/classification',
  documents: '/documents',
  tickets: '/tickets',
  customergroups: '/customergroups',
  customers: '/customers',
  pointofsales: '/pointofsales',
  areas: '/areas',
  address: '/address',
  partnergroups: '/partnergroups',
  partners: '/partners',
  contactpersons: '/contactpersons',
  contracts: '/contracts',
  serviceobjects: '/serviceobjects',
  servicecontracts: '/servicecontracts',
  locations: '/locations',
  processes: '/processes',
  monthlyindex: '/monthlyindex',
  administration: '/administration',
  operatingcostinvoices: '/operatingcostinvoices',
  costinvoiceobjections: '/costinvoiceobjections',
  sfmpositions: '/sfmpositions',
  emails: '/emails',
  import: '/import',
  teams: '/teams',
  msEntra: '/v1/auth/login',
  '403': '/error-403',
  '404': '/error-404',
};
